module.exports = __webpack_public_path__ + "static/media/info-icon.2573b996.svg";